import { connect } from 'react-redux';
import { isSectionUserProgressComplete } from '@core/materials/selectors';
import {
  getUserPermissionsInCurrentSpace,
  hasPermission,
  MATERIAL_PERMISSIONS,
} from '@core/utils/permissions';

import { MATERIAL_TITLE_HINT } from '../../../../../constants/texts';
import * as classRoomSelectors from '../../../../../../core/selectors/classroom';
import {
  canEditMaterials,
  canViewMaterials,
  canAccessEducatorArea,
  isMaterialRbacEnabled,
} from '../../../../../../core/materials/permissions';
import {
  selectors as materialSelectors,
  operations,
} from '../../../../../store/materials';
import { selectSectionInJourney } from '../../../../../actions/materials';
import SectionListItem from './SectionListItem';

const mapStateToProps = (state, ownProps) => {
  const section = materialSelectors.getMaterial(state, ownProps.materialId);
  const currentSectionId = materialSelectors.currentSectionId(state);
  // In educator area: if user has educator area permission, they can do everything
  const canEdit = ownProps.educatorOnly
    ? canAccessEducatorArea(state)
    : canEditMaterials(state);
  const canView = ownProps.educatorOnly
    ? canAccessEducatorArea(state)
    : canViewMaterials(state);
  const isStudent = classRoomSelectors.getIsStudent(state);
  const isRbacEnabled = isMaterialRbacEnabled(state);
  const permissions = getUserPermissionsInCurrentSpace(state);
  // When RBAC is disabled, fallback to student check (legacy behavior)
  // When RBAC is enabled, only return true if user has progress permission
  const hasProgressPermission = hasPermission(
    state,
    MATERIAL_PERMISSIONS.PROGRESS,
    isStudent
  );

  return {
    isInstructor: classRoomSelectors.isInstructor(state),
    isStudent,
    primaryText: section.title || MATERIAL_TITLE_HINT,
    hidden: section.hidden,
    parent: section.parent,
    selected: ownProps.materialId === currentSectionId,
    sectionCompleted: isSectionUserProgressComplete(state, ownProps.materialId),
    canEdit,
    canView,
    permissions,
    isRbacEnabled,
    hasProgressPermission,
  };
};

const mapDispatchToProps = (dispatch, { materialId, educatorOnly }) => ({
  onClick: () => dispatch(selectSectionInJourney(materialId, educatorOnly)),
  onReorder: (params) =>
    dispatch(operations.reorderMaterial({ ...params, educatorOnly })),
});

export default connect(mapStateToProps, mapDispatchToProps)(SectionListItem);
